module.exports = __webpack_public_path__ + "img/png.c481caeb.png";